/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td
const timeDate = require ('../../../../../js-handler/time-date')


export const tableDetail = {
    entity: 'sentpayment',//name table on the db
    dest: 'sentpayment',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail:`data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"sentpayment", "elem":"fullcont", "id":"sentpayment-fullcont", "act":"selectOne", "entity":"sentpayment", "dbid": "#dbid"}  ],
                                
                                 "clickRight": [{"dest":"sentpayment", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"sentpayment", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields : ["sentpayment.code","provider.name","purchase.code","provider.code"],
        mainFilterValues : ["", ""],         
        andFilterFields  : ["sentpayment.check_generation_active", "sentpayment.check_status"],
        andFilterValues  : ["", ""],
    }

}

/****************ELEMENTS*****************/
//each element could organize their data diferent
export function organizeRow(data){ //console.log('organizeRow>')

    var newData = []

    if(data.length === 0){
        newData.push({   id: 'nothing', colum: [{ label:'No Results', span: ''},
                                                { label:'', span: '' },
                                                { label:'', span: '' },
                                                { label:'', span: '' },
                                                { label:'', span: '' },
                                                { label:'', span: '' }
                                                ] })
        return newData
    }


    data.forEach((elem)=>{
        const usesCheck = elem.check_generation_active === 'true'
        const paymentMethod = usesCheck
            ? {
                label: 'Check',
                description: 'This payment was made by check',
                color: 'td-blue-icon',
                icon: 'receipt'
            }
            : {
                label: 'Paid',
                description: 'This payment was made without a check',
                color: 'td-green-icon',
                icon: 'cash'
            }
        const checkStatus = getCheckStatus(elem.check_status, usesCheck)
        const rowDataDetail = `data-detail='{ "click": [
                                            {"dest":"ripple"},
                                            {"dest":"sentpayment", "elem":"fullcont", "id":"sentpayment-fullcont", "act":"selectOne", "entity":"sentpayment", "dbid":"${elem.id}"}
                                          ],
                                          "clickRight": [
                                            {"dest":"sentpayment", "elem":"dt", "act":"trMenu", "id":"trMenu", "entity":"sentpayment", "dbid":"${elem.id}", "checkGenerationActive":"${usesCheck ? 'true' : ''}"}
                                          ] }'`

        newData.push(
            {   id: elem.id, tdDataDetail: rowDataDetail,
                colum: [  { label: elem.provider_name, span: elem.code,
                                            style:{ 
                                                tdClass:'tdWithAvatar',  
                                                avatar:elem.provider_avatar,
                                                avatarColor: elem.avatarColor, 
                                                avatarColorLetter: elem.avatarColorLetter, 
                                                avatarLetter: elem.avatarLetter 
                                                
                                            }
                                         },  
                                         { label: elem.accounts_name, span: elem.reference_number,
                                            style:{ 
                                                tdClass:'tdWithAvatar',  
                                                avatar:elem.accounts_avatar,
                                                avatarColor: elem.accounts_avatar_color, 
                                                avatarColorLetter: elem.accounts_avatar_color_letter, 
                                                avatarLetter: elem.accounts_avatar_letter 
                                                
                                            }
                                         },
                                         { label: elem.amount_dt, span: elem.date_dt},
                                         { label: elem.paid_bills_count, span: elem.paid_bills},
                                         { label: paymentMethod.label, span: paymentMethod.description,
                                            style: {
                                                tdClass: `tdWithIcon ${paymentMethod.color}`,
                                                svg: `./css/svg.svg#${paymentMethod.icon}`
                                            }
                                         },
                                         { label: checkStatus.label, span: checkStatus.description,
                                            style: checkStatus.icon ? {
                                                tdClass: `tdWithIcon ${checkStatus.color}`,
                                                svg: `./css/svg.svg#${checkStatus.icon}`
                                            } : {}
                                         }
                                        ]    
            }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/

function getCheckStatus(status, usesCheck) {
    if (!usesCheck) {
        return {
            label: '-',
            description: '-',
            color: '',
            icon: ''
        }
    }

    switch (status) {
        case 'Generated':
            return {
                label: 'Generated',
                description: 'The check has been generated but not printed',
                color: 'td-red-icon',
                icon: 'warning'
            }

        case 'Printed':
            return {
                label: 'Printed',
                description: 'The physical check has been printed by the system',
                color: 'td-orange-icon',
                icon: 'print'
            }

        case 'Clear':
            return {
                label: 'Clear',
                description: 'The check has been cashed and the transaction has been completed',
                color: 'td-gray-icon',
                icon: 'check-round'
            }

        default:
            return {
                label: 'Pending',
                description: 'Check status not assigned',
                color: 'td-gray-icon',
                icon: 'timelapse'
            }
    }
}

export function updatePrintedRows(rows) {
    const printedRows = Array.isArray(rows) ? rows : []

    printedRows.forEach((row) => {
        if (row?.check_status !== 'Printed') { return }

        const htmlRow = document.getElementById(`sentpayment-tableRow-${row.id}`)
        const statusCell = htmlRow?.lastElementChild

        if (statusCell === null || statusCell === undefined) { return }

        // Solo cambia la celda del estado; no reconstruye ni recarga el DT.
        statusCell.className = 'tdWithIcon td-orange-icon'
        statusCell.querySelector(':scope > label').textContent = 'Printed'
        statusCell.querySelector(':scope > span').textContent = 'The physical check has been printed by the system'

        let icon = statusCell.querySelector(':scope > svg')
        if (icon === null) {
            statusCell.insertAdjacentHTML('beforeend', '<svg><use></use></svg>')
            icon = statusCell.querySelector(':scope > svg')
        }

        icon.querySelector('use').setAttribute('xlink:href', './css/svg.svg#print')
    })
}
